module.exports = __webpack_public_path__ + "img/海关.84007cdd.svg";